"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _IconChevronDownOutline = _interopRequireDefault(require("./IconChevronDownOutline"));
var IconChevronLeftOutline = /*#__PURE__*/(0, _styledComponents.default)(_IconChevronDownOutline.default).withConfig({
  displayName: "IconChevronLeftOutline",
  componentId: "c11n-8-107-0__sc-hujn6u-0"
})(["transform:rotate(90deg);"]);
var _default = IconChevronLeftOutline;
exports.default = _default;